import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import tvTheme, { tvTextStroke } from './tvTheme';

/** 画面枠の外側に付ける番号ラベル（画面内には入れない） */
function TVFrameLabel({ frameNumber, frameTitle, large = false }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.75,
        mb: large ? 0.75 : 0.5,
      }}
    >
      <Typography
        component="span"
        sx={{
          fontSize: large ? '1.1rem' : '0.8rem',
          fontWeight: 900,
          color: tvTheme.colors.titleOrange,
          ...tvTextStroke('#fff'),
        }}
      >
        {String(frameNumber).padStart(2, '0')}
      </Typography>
      {frameTitle && (
        <Typography
          component="span"
          sx={{
            fontSize: large ? '1.05rem' : '0.85rem',
            fontWeight: 800,
            color: tvTheme.colors.textDark,
          }}
        >
          {frameTitle}
        </Typography>
      )}
    </Box>
  );
}

TVFrameLabel.propTypes = {
  frameNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  frameTitle: PropTypes.string,
  large: PropTypes.bool,
};

export default TVFrameLabel;
